// 기본 Input Type
import {
    Box,
    Button,
    Grid,
    SelectChangeEvent,
    Tab, Tabs, } from "@mui/material";
import React, {SyntheticEvent, useState, useCallback} from "react";
import {
    inputCrawlingInterface,
    inputCrawlingParamsInitial
} from "../../../api/definition";

import {CrawlingInputConfig} from "./InputDetail/crawlingInputConfig";
import {CrawlingInputParams} from "./InputDetail/crealingInputParams";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const {children, value, index, ...other} = props;

    return (
        <Grid item lg={12} md={12} sm={12} xs={12} sx={{mt:1}}
            hidden={value !== index}>
            <div
                role="tabpanel"
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && <Box>{children}</Box>}
            </div>
        </Grid>
    )
}

export function CrawlingInput(props: any) {
    const [crawlingInput, setCrawlingInput] = useState<inputCrawlingInterface>(props.input);
    const [index, setIndex] = useState(0);

    const handleChangeTab = useCallback((event: SyntheticEvent, index: number) => {
        setIndex(index);
    }, []);

    const handleInputPageType = (event: SelectChangeEvent) => {
        let value: string = event.target.value;
        props.setInput({
            ...props.input,
            'pageType': value
        });
    }

    const handleInputParam = (event: React.ChangeEvent<HTMLTextAreaElement>, index:number) => {
        const inputKey = event.target.id;
        const info = inputKey.split('_');

        const changeKey = info[3]
        const value = event.target.value;

        props.setInput((prevInput: inputCrawlingInterface) => {
            const updatedParams = [...(prevInput.params || [])];
            updatedParams[index] = {
                ...updatedParams[index],
                [changeKey]: value
            };
            return {
                ...prevInput,
                params: updatedParams,
            };
        });
    }

    const handleInputParamType = (event: SelectChangeEvent, index: number) => {
        let value = event.target.value;
        props.setInput((prevInput: inputCrawlingInterface) => {
            const updatedParams = [...(prevInput.params || [])];
            updatedParams[index] = {
                ...updatedParams[index],
                'type': value
            };
            return {
                ...prevInput,
                params: updatedParams,
            };
        });
    }

    const handleInputParamAdd = useCallback(() => {
        const currentParams = props.input.params || [];
        const newParams = [...currentParams, inputCrawlingParamsInitial()];

        props.setInput({
            ...props.input,
            params: newParams
        })
    }, [props.input]);

    const handleInputParamRemove = (index: number) => {
        props.setInput((prevInput: inputCrawlingInterface) => {
            const updatedParams = [...(prevInput.params || [])];
            updatedParams.splice(index, 1);
            return {
                ...prevInput,
                params: updatedParams,
            };
        });
    };


    return (
        <Grid container spacing={1} sx={{mt:1}}>
            <Grid item lg={10} md={10} sm={10} xs={10}>
                <Tabs value={index} onChange={handleChangeTab}>
                    <Tab label="Config" value={0}/>
                    <Tab label="Params" value={1} />
                </Tabs>
            </Grid>
            {index === 1 &&
                <Grid item lg={2} md={2} sm={2} xs={2} sx={{ display: 'flex',
                    justifyContent: 'flex-end', p: 2}}>
                <Button
                    variant='contained'
                    onClick={handleInputParamAdd}
                >매핑추가</Button>
            </Grid>
            }
            <CustomTabPanel index={0} value={index}>
                <CrawlingInputConfig input={props.input} handleCrawlingInput={props.handleInput}
                                     handleInputPageType={handleInputPageType}
                                    ></CrawlingInputConfig>
            </CustomTabPanel>
            <CustomTabPanel index={1} value={index}>
                <CrawlingInputParams input={props.input}
                                    handleInputParamRemove={handleInputParamRemove}
                                    handleInputParam={handleInputParam}
                                    handleInputParamType={handleInputParamType}></CrawlingInputParams>
            </CustomTabPanel>
        </Grid>
    )
}

